import {
  FETCH_REFER_EARN_OPTIONS,
  FETCH_REFERRAL_LOGS,
  USER_LOGOUT,
  FETCH_REFERRAL_CODE,
  FETCH_REFERRAL_VALUE,
  SEND_MULTIPLE_REFERRAL_REQUESTS,
} from 'actions/apiActionConstants'
import { reducerSwitch, createReducer } from 'lib/redux/reducerUtils'
import { API_CALL_REQUEST, API_CALL_FAILURE, API_CALL_SUCCESS } from 'actions/actionConstants'

const initialState: App.ReferState = {
  earnOptions: [],
  referralLogs: undefined,
  referralCode: undefined,
  referralValue: undefined,
  fetching: false,
  referralRequestsSent: undefined,
  utm: undefined,
}

const apiRequests = reducerSwitch<App.ReferState>({
  [FETCH_REFER_EARN_OPTIONS]: () => ({
    fetching: true,
  }),

  [FETCH_REFERRAL_LOGS]: () => ({
    fetching: true,
  }),

  [FETCH_REFERRAL_CODE]: () => ({
    fetching: true,
  }),

  [FETCH_REFERRAL_VALUE]: () => ({
    fetching: true,
  }),

  [SEND_MULTIPLE_REFERRAL_REQUESTS]: () => ({
    fetching: true,
  }),
})

const apiSuccesses = reducerSwitch<App.ReferState>({
  [FETCH_REFER_EARN_OPTIONS]: (state, action) => ({
    earnOptions: action.data.result.earn_options,
    fetching: false,
  }),

  [FETCH_REFERRAL_LOGS]: (state, action) => ({
    referralLogs: action.data.result,
    fetching: false,
  }),

  [FETCH_REFERRAL_CODE]: (state, action) => ({
    referralCode: action.data.result.details.referral_code,
    utm: action.data.result.meta_data,
    fetching: false,
  }),

  [FETCH_REFERRAL_VALUE]: (state, action) => ({
    referralValue: action.data.result,
    fetching: false,
  }),

  [SEND_MULTIPLE_REFERRAL_REQUESTS]: (state, action) => ({
    fetching: false,
    referralRequestsSent: action.data,
  }),

  [USER_LOGOUT]: () => ({
    referralLogs: undefined,
    referralCode: undefined,
    utm: undefined,
    referralRequestsSent: undefined,
  }),
})

const apiFailures = reducerSwitch<App.ReferState>({
  [FETCH_REFER_EARN_OPTIONS]: () => ({
    earnOptions: [],
    fetching: false,
  }),

  [FETCH_REFERRAL_LOGS]: () => ({
    fetching: false,
    referralLogs: undefined,
  }),

  [FETCH_REFERRAL_VALUE]: () => ({
    fetching: false,
    referralValue: undefined,
  }),

  [SEND_MULTIPLE_REFERRAL_REQUESTS]: () => ({
    fetching: false,
    referralRequestsSent: undefined,
  }),

})

export default createReducer<App.ReferState>(initialState, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
})
